export const BACK_TO_COVER_TYPE = "Back to 'Cover type'";
export const BACK_TO_YOURS_COVER = "Back to 'Your cover'";
export const BACK_TO_YOUR_DETAILS = "Back to 'Your details'";
export const BACK_TO_YOUR_APPLICATIONS = "Back to 'Your application'";
export const CONTINUE_TO_PROPERTY_DETAILS = "CONTINUE TO PROPERTY DETAILS";
export const CONTINUE_TO_COVER = "CONTINUE TO COVER OPTIONS";
export const TITLE_LABEL = "Title";
export const TITLE_HELP_TEXT = "Please select your title.";

export const FIRST_NAME_LABEL = "First name";

export const LAST_NAME_LABEL = "Last name";

export const DATE_OF_BIRTH_LABEL = "Date of birth";

export const OCCUPATION_LABEL = "What's your job title?";
export const OCCUPATION_HINT_HELP_TEXT =
  "Please enter your main occupation. If you can’t find your exact job title then please find a closely related job title or role from the list.";
export const SECOND_OCCUPATION_LABEL = "What’s their job title?";
export const SECOND_OCCUPATION_HINT_HELP_TEXT =
  "Please enter their main occupation. If you can’t find their exact job title then please find a closely related job title or role from the list.";
export const FULL_TIME_STUDENT = "Are you a full-time student?";
export const FULL_TIME_STUDENT_HINT_TEXT =
  "You should answer yes if your current course lasts at least 24 weeks during one calendar or academic year and minimum 21 hours of study, tuition or work experience per week during term time.";
export const FULL_TIME_STUDENT_HINT_TEXT_2 =
  "You should answer yes if their current course lasts at least 24 weeks during one calendar or academic year and minimum 21 hours of study, tuition or work experience per week during term time.";
export const FULL_TIME_STUDENT_2 =
  "Is the second policyholder a full-time student?";
export const INDUSTRY_LABEL = "What industry do you work in?";
export const INDUSTRY_HELP_TEXT =
  "Please select the industry you currently work in. If an exact match is not available, please select the closest available option.";
export const INDUSTRY_HINT_TEXT =
  "Please enter the industry you work in. If you can't find your exact industry then please find something closely related from the list.";
export const SECOND_INDUSTRY_LABEL = "What industry do they work in?";
export const SECOND_INDUSTRY_HINT_TEXT =
  "Please enter the industry they work in. If you can’t find their exact industry then please find something closely related from the list.";
export const SECOND_INDUSTRY_HELP_TEXT =
  "Please select the industry they currently work in. If an exact match is not available, please select the closest available option.";

export const SECOND_APPLICANT_INCLUDED_LABEL =
  "Would you like to add a joint policyholder? (Optional)";
export const SECOND_APPLICANT_INCLUDED_LABEL_TOGGLE =
  "Add another policyholder";
export const SECOND_APPLICANT_INCLUDED_HELP_TEXT =
  "Adding another policyholder will allow them to make policy amendments, make a claim or cancel the policy. If you would like to add another policyholder, please select the plus icon.";

export const PREVIOUS_HOME_COVER =
  "Have you made any home insurance claims in the last five years?";
export const PREVIOUS_HOME_COVER_HINT_TEXT =
  "Please include all home insurance claims made by anyone living in your house, even if the claim was not paid out.";
export const HOME_SECOND_OCCUPATION_HINT_TEXT =
  "Please select their current occupation. If an exact match is not available, please select the closest available option.";

export const PREVIOUS_LANDLORDS_COVER =
  "Have you previously held Landlord’s Insurance?";
export const PREVIOUS_LANDLORDS_COVER_HELP_TEXT =
  "Please tell us if you have previously had landlord’s insurance on ANY property in the United Kingdom. If you have never had landlord’s insurance before, we automatically apply an introductory no claims discount of two years.";
export const LANDLORDS_BUILD_YEAR_HELP_TEXT =
  "Please enter the year that the property was built. If the exact year is not known, the customer can provide us with the closest estimate possible.";
export const LANDLORDS_ROOF_CONSTRUCTION_HELP_TEXT =
  "Please select the construction type of the property's roof.";
export const LANDLORDS_WALL_CONSTRUCTION_HELP_TEXT =
  "Please select the construction type of the property's walls.";

export const NO_OF_RENTAL_PROPERTIES_LABEL = "How many properties do you own?";
export const NO_OF_RENTAL_PROPERTIES_LABEL_HELP_TEXT =
  "Please specify the amount of rental properties you currently own. If insuring in the name of a business, please confirm the number of properties owned by the business. <br/><br/>Unfortunately, we can't offer cover if you have more than 10 rental properties (including this one).";

export const UNAPPROVED_MORTGAGE_APPLICATION =
  "Is this insurance for a property that is subject to a new mortgage application?";
export const UNAPPROVED_MORTGAGE_APPLICATION_HELP_TEXT =
  "If you are applying for a new mortgage or remortgaging to buy the property, please select 'Yes'. If you already have a mortgage approved for this property or own the property outright, please select 'No'. ";

export const PREVIOUS_CLAIM_LABEL =
  "Have you or any member of your family living with you made any landlord’s claim in the last 5 years?";
export const PREVIOUS_CLAIM_HINT_TEXT =
  "Please include all landlord’s insurance claims made for any of your properties, even if the claim was not paid out.";

export const PREVIOUS_CLAIM_CLAIMED_UNDER = "Claimed under";
export const PREVIOUS_CLAIM_TYPE_OF_LOSS = "Type of claim";
export const PREVIOUS_DATE_OF_CLAIM = "Date of claim";
export const PREVIOUS_CLAIM_AMOUNT = "Cost of claim";

export const POST_CODE = "Postcode";
export const STREET = "Property house number and street name";
export const DISTRICT = "District";
export const TOWN = "Town";
export const COUNTY = "County";
export const INPUT_FINDER = "Find your property";
export const PROPERTY_TYPE = "What is your property type?";
export const HOME_PROPERTY_TYPE = "Property Type";
export const BUILD_YEAR = "What year was your property built? ";
export const HOME_BUILD_YEAR = "Property Build Year ";
export const NUMBER_OF_BEDROOMS = "How many bedrooms does your property have?";
export const NUMBER_OF_BATHROOMS =
  "How many bathrooms does your property have?";
export const NUMBER_OF_BATHROOMS_NOTE =
  "Bathrooms include en-suites, wetrooms, toilet rooms and shower rooms, the number above should include these.";
export const NUMBER_OF_CHILDREN =
  "Number of children (17 and under) living in the property";
export const NUMBER_OF_ADULTS = "Number of adults (18+) living in the property";
export const HOME_NUMBER_OF_BEDROOMS = "Number of Bedrooms";
export const HOME_NUMBER_OF_BATHROOMS = "Number of Bathrooms";
export const WALL_CONSTRUCTION = "What type of walls does your property have?";
export const ROOF_CONSTRUCTION = "What type of roof does your property have?";
export const HOME_WALL_CONSTRUCTION = "Wall Type";
export const HOME_ROOF_CONSTRUCTION = "Roof Type";
export const WINDOW_LOCKS_FITTED =
  "Are all windows fitted with key operated window locks?";
export const ALARM_TYPE = "What type of burglar alarm does your property have?";
export const UNOCCUPIED_NINETY_DAYS =
  "Will the property be left unoccupied for a total of more than 90 days in a row?";
export const NON_ROUTINE_BUILDING_WORK =
  "Is there work currently taking place on the building which is not routine, repair, maintenance or decoration?";
export const NON_ROUTINE_BUILDING_WORK_VALUE =
  "What is the value of the work(s) taking place?";
export const NON_ROUTINE_BUILDING_WORK_JCT_CONTRACT =
  "Is there a building or construction contract in place covering the work(s)?";
export const STUDENT_TENANTS = "Will the property be let to students?";
export const DSS_TENANTS =
  "Will the property be let to tenants funding rent through the benefits agency?";
export const NO_CLAIMS_BUILDINGS =
  "How many years no claims discount do you have for buildings insurance?";
export const NO_CLAIMS_CONTENTS =
  "How many years no claims discount do you have for contents insurance?";
export const HOME_NO_CLAIMS_BUILDINGS =
  "What is your current no claims discount for Buildings?";
export const HOME_NO_CLAIMS_CONTENTS =
  "What is your current no claims discount for Contents?";

export const PROPERTY_TYPE_HELP_TEXT = "What is your property type?";
export const HOME_BUILD_YEAR_HELP_TEXT =
  "Please enter the build year of the property e.g. 1995. <br> We are able to accept one year greater than the current year to allow for new build properties. <br> If the exact year is not known please provide the closest estimate possible.";
export const BUILD_YEAR_HELP_TEXT =
  "Please tell us the year your property was built. For example, 1956. If you don't know the build year of the property, it can normally be found within the title deeds, a mortgage valuation or a previous property survey. If you’re unsure, please provide the closest estimate possible. ";
export const NUMBER_OF_BEDROOMS_HELP_TEXT =
  "Please tell us how many bedrooms the property has. You need to include rooms that were originally designed for sleeping in, even if they are now used for other purposes, and rooms that have been adapted or converted for sleeping in. For example, loft conversions.";
export const NUMBER_OF_BATHROOMS_HELP_TEXT =
  "Please tell us how many bathrooms the property has. You should include wet-rooms, ensuites, toilet rooms and shower rooms. ";
export const WALL_CONSTRUCTION_HELP_TEXT =
  "Please tell us what the walls of the property are constructed of. If the walls are made up of more than one material, select the main construction material. For example, if the walls are 70% brick and 30% concrete, select brick.<br><br> If the walls are made up of equal amounts of more than one construction material then we’ll accept either one. For example, if the wall construction is 50% brick and 50% concrete, you can select either. ";
export const ROOF_CONSTRUCTION_HELP_TEXT =
  "Please tell us what the roof of the property is constructed of. If the roof is made up of more than one material, select the main construction material. For example, if the roof is 70% tile and 30% asphalt, select tile.<br><br> If the roof is made up of equal amounts of more than one construction material then we’ll accept either one. For example, if the roof construction is 50% tile and 50% asphalt, you can select either. .";
export const WINDOW_LOCKS_FITTED_HELP_TEXT =
  "Please select ‘Yes’ if all the windows to the property are secured by key operated window locks. If one or more windows are not key operated, please select ‘No’. ";
export const ALARM_TYPE_HELP_TEXT =
  "Please tell us whether the burglar alarm on the property is annually maintained by a professional, or if it’s non-maintained. If there’s an alarm fitted to the building that’s not in use, select ‘No Alarm’. ";
export const UNOCCUPIED_NINETY_DAYS_HELP_TEXT =
  "You must tell us if the property is not going to be lived in by tenants for more than 90 days in a row. For a property to be ‘lived in’ it must be slept in frequently. ";
export const NON_ROUTINE_BUILDING_WORK_HELP_TEXT =
  "You must tell us if there is currently any work taking place on the building such as structural work or extensions. This does not include routine repair work, general maintenance or decorating.";
export const NON_ROUTINE_BUILDING_WORK_VALUE_HELP_TEXT =
  "The customer must tell us the overall value of the building work being carried out.";
export const NON_ROUTINE_BUILDING_WORK_JCT_CONTRACT_HELP_TEXT =
  "We need to know whether the work being done is under a contract. For example, a Joint Contracts Tribunal (also called a JCT) will produce a contract for construction, guidance notes and other standard documentation. ";
export const STUDENT_TENANTS_HELP_TEXT =
  "You must tell us if the property will be let to students.";
export const DSS_TENANTS_HELP_TEXT =
  "You must tell us if the property will be let to tenants funding their rent through the Department of Work and Pensions. ";
export const NO_CLAIMS_BUILDINGS_HELP_TEXT =
  "Please tell us how many years no claims discount you have for buildings insurance. If you’re a first time buyer, we apply an introductory no claims discount of 2 years. ";
export const NO_CLAIMS_CONTENTS_HELP_TEXT =
  "Please tell us how many years no claims discount you have for contents insurance. If you’re a first time buyer, we apply an introductory no claims discount of 2 years. ";
export const HOME_NO_CLAIMS_BUILDINGS_HELP_TEXT =
  "Please select your current no claims discount entitlement for buildings insurance, which can be obtained from your previous insurer’s policy documentation. <br>If the customer is a first time buyer, then remember to apply the 2 year introductory NCD.";
export const HOME_NO_CLAIMS_CONTENTS_HELP_TEXT =
  "Please select the current no claims discount entitlement for contents insurance.<br>This can be found on the current insurer's policy documentation.<br>If the customer is a first time buyer, then remember to apply the 2 year introductory NCD; or the clients current NCD entitlement, whichever is higher.";
export const TENANTS_NO_CLAIMS_CONTENTS_HELP_TEXT =
  "Please select your client's current contents no claims discount. This can be found on their previous insurers' policy documentation.";
export const TENANTS_NO_CLAIMS_CONTENTS_HINT_TEXT =
  "Please select the current no claims discount. This can be found on your current policy documentation. If you have made a claim or multiple claims this year, please check the information with your insurer.";
export const PREVIOUS_HELD =
  "Have you, or anyone insured under this policy previously held Contents Insurance?";
export const TENANTS_PREVIOUS_CLAIM_LAST_FIVE_YEAR =
  "Have you or anyone living at the property made any contents insurance claims in the last 5 years?";
export const TENANTS_PREVIOUS_CLAIM_LAST_FIVE_YEAR_HELP_TEXT =
  "Please list only claims made on contents policies in the last 5 years.";

export const ALARM_TYPE_HINT =
  "If there is an alarm fitted to the building that is not in use, please select 'No alarm'.";
export const UNOCCUPIED_NINETY_DAYS_HINT =
  "For a property to be considered ‘occupied’, it must be slept in frequently.";
export const NON_ROUTINE_BUILDING_WORK_HINT =
  "This work includes structural work and extensions.";
export const NON_ROUTINE_BUILDING_WORK_VALUE_HINT =
  "What is the value of the works (contract value)?";
export const NON_ROUTINE_BUILDING_WORK_JCT_CONTRACT_HINT =
  "Is there a JCT Contract in place covering the works?";
export const STUDENT_TENANTS_HINT = "Will the property be let to students?";
export const DSS_TENANTS_HINT =
  "Will the property be let to tenants funding rent through the benefits agency?";
export const NO_CLAIMS_BUILDINGS_HINT =
  "You should be able to find this on your previous insurer’s policy documentation.";
export const NO_CLAIMS_CONTENTS_HINT =
  "You should be able to find this on your previous insurer’s policy documentation.";

export const POST_CODE_LABEL_MSG = "Postcode";
export const STREET_LABEL_MSG = "Property house number and street name";
export const DISTRICT_LABEL_MSG = "District";
export const TOWN_LABEL_MSG = "Town";
export const COUNTY_LABEL_MSG = "County";
export const PROPERTY_TYPE_LABEL_MSG = "Property type";
export const BUILD_YEAR_LABEL_MSG = "Property build year";
export const BUILD_YEAR_FORMAT_MSG =
  "Please enter a 4 digit year for example 1995.";
export const BUILD_YEAR_RANGE_MSG =
  "Please enter a build year between {0} and {1}";
export const NUMBER_OF_BEDROOMS_LABEL_QUESTION =
  "How many bedrooms does the property have?";

export const NUMBER_OF_BEDROOMS_LABEL_MSG = "Number of bedrooms ";
export const NUMBER_OF_BATHROOMS_LABEL_MSG = "Number of bathrooms ";
export const WALL_CONSTRUCTION_LABEL_MSG = "Wall type ";
export const ROOF_CONSTRUCTION_LABEL_MSG = "Roof type ";
export const NO_CLAIMS_BUILDINGS_LABEL_MSG = "Buildings no claims discount ";
export const NO_CLAIMS_CONTENTS_LABEL_MSG = "Contents no claims discount ";
export const NON_ROUTINE_BUILDING_WORK_VALUE_LABEL_MSG =
  "What is the value of the work(s) taking place? ";
export const NON_ROUTINE_BUILDING_WORK_VALUE_MAX_LABEL_MSG =
  "What is the value of the work(s) taking place? field must be 999,999.99 or less.";
export const NON_ROUTINE_BUILDING_WORK_VALUE_MIN_LABEL_MSG =
  "What is the value of the work(s) taking place? field must be 0.01 or more.";

export const SELECT_DEFAULT_PLACEHOLDER = "Please select...";

export const NO_MATCHING_DATA_OCCUPATION =
  "We couldn’t find that job title in our database, please check your spelling or try to different job title type.";
export const NO_MATCHING_DATA_INDUSTRY =
  "We couldn’t find that industry in our database, please check your spelling or try to different industry type.";

export const PAYMENT_METHOD_LABEL = "How would you prefer to pay?";
export const ALERT_PAYMENT_SECURE = "Your payment is secure.";
export const PAYMENT_DETAILS = "Payment details";
export const ACCOUNT_HOLDER_NAME = "Account holder name";
export const SORT_CODE = "Sort code";
export const ACCOUNT_NUMKBER = "Account number";
export const DIRECT_DEBIT_DATE =
  "What date do you want your monthly payment to be made?";
export const STAY_COVERED = "Stay covered";
export const FREQUENTLY_PAYMENT = "How frequently would you like to pay?";
export const CONTENTS_COVER =
  "What amount of contents cover is required? The amount must cover the cost of replacing all contents as new.";
export const BASIS_OF_ADVICE = "Basis of advice";
export const DOCUMENT_DELIVERY_PREFERENCE =
  "How would you like to receive your documents?";
export const SPECIFY_CORRESPONDENCE_ADDRESS =
  "Would you like to add a correspondence address?";
export const SPECIFY_CORRESPONDENCE_ADDRESS_HELP_TEXT =
  "Please indicate if the customer wishes to use an alternative address to receive correspondence.";
export const SPECIFY_CORRESPONDENCE_ADDRESS_HINT_TEXT =
  "Please start typing your address or postcode and select your property from the list of results. If we cannot find your property you can choose to enter the details manually.";

export const TERM_OF_INSURANCE = "Term of insurance";
export const TERM_OF_INSURANCE_HELP_TEXT =
  "Please confirm the term of insurance required by the applicant. This should coincide with the initial period of their rental agreement.";

export const CREDIT_ARRANGED =
  "Have you arranged the mortgage to be covered by this product?";
export const CREDIT_ARRANGED_HINT_TEXT =
  "Due to regulatory requirements you must inform us if you have arranged the mortgage to be protected by the product.";
export const CREDIT_ARRANGED_HELP_TEXT =
  "Due to regulatory requirements you must inform us if you have arranged the mortgage to be protected by the product.";
export const AWARE_OF_CLAIM_CARER =
  "Are you currently aware of any circumstances which may result in you making a claim under this policy to become a carer?";
export const AWARE_OF_CLAIM_CARER_HELP_TEXT =
  "If the customer answers ‘Yes' to this question, then they will not be eligible for Unemployment cover.";
export const AWARE_JOB_AT_RISK =
  "Are you aware of any circumstances where you have received formal or informal notification that your own job might be at risk?";
export const AWARE_JOB_AT_RISK_HELP_TEXT =
  "The customer will be unable to claim for unemployment if they had received formal or informal notification that their job might be at risk in the 6 months prior to the policy start date.";
export const AWARE_FORMAL_NOTIFICATION_OF_CUTS =
  "Are you aware of any circumstances where your employer has formally announced its intention to make cuts to its workforce?";
export const AWARE_FORMAL_NOTIFICATION_OF_CUTS_HELP_TEXT =
  "The customer will be unable to claim for unemployment if at the policy start date they were aware that their employer intended to make cuts to staff numbers.";
export const FORMAL_ADMINISTRATION_OR_LIQUIDATION =
  "Is your company or the company you are employed by, either currently in or has it announced formally or informally it is going into administration, receivership or liquidation?";
export const FORMAL_ADMINISTRATION_OR_LIQUIDATION_HELP_TEXT =
  "The customer will be unable to claim for unemployment if at the policy start date their company or the company they are employed by has announced formally or informally that they are in, or going into administration, receivership or liquidation.";
export const GROSS_MONTHLY_INCOME = "Gross monthly income (£)";
export const GROSS_MONTHLY_INCOME_HELP_TEXT =
  "This is the customer's average monthly salary before tax including any commission and/or bonus received for the 12 months before the policy start date (if in full-time employment) or the monthly average of income as declared on the self assessment return for the previous tax year as confirmed by HMRC (if self employed).";
export const USE_CORRESPONDENCE_ADDRESS_HELP_TEXT =
  "Please select 'Yes' and enter the details below, if you would like your policy documents to be posted to a different address.<br><br> If you would like your policy documents to be posted to the insured address, please select 'No'<br><br> Please note, we will continue to send your policy documents to this correspondence address, unless you contact us to change the address or remove the correspondence address.";
export const USE_MORTGAGE_INFORMATION_HELP_TEXT =
  "If you need to add your mortgage lender’s details to your home insurance certificate, please select 'Yes' and provide the name of your mortgage lender and your mortgage completion date.<br><br> If you do not need to add your mortgage lender’s details, please select 'No'.";
export const USE_SOLICITOR_INFORMATION_HELP_TEXT =
  "If you need to add your solicitor’s details to your home insurance certificate, please select 'Yes', and provide your solicitor’s name, address and email address.<br><br> If you do not need to add your solicitor’s details, please select 'No'.";
export const SOLICITOR_ADDRESS_FINDER_INPUT_DESCRIPTION =
  "Please start typing the address or postcode of your solicitor and select from the list of results. If we can’t find the property you can choose to enter the details manually.";
export const EMAIL_ACCEPT_TO_SOLICITOR_HELP_TEXT =
  "If your solicitor has requested evidence of your intention to insure the property, please select 'Yes' and enter your solicitors email address.<br><br> If your solicitor does not require this evidence, please select 'No'.";
export const EMAIL_NOTIFICATION_TO_SOLICITOR_HELP_TEXT =
  "If your solicitor has requested evidence of you insuring the property, please select 'Yes' and enter your solicitors email address.<br><br> If your solicitor does not require this evidence, please select 'No'.";
export const INSURED_PARTY_RP_TEXT =
  "Are you a landlord or a letting agent/ Registered Company or Private Landlord?";
export const INSURED_PARTY_RP_HINT_TEXT =
  "In order to purchase this policy, the applicant must own the insured property or be legally responsible for the collection of rent.";
